import axios from '@/utils/http.js'

const permission = {
    url: {
        get: "/permission/get",
        getPage: "/permission/getPage",
        add: "/permission/add",
        update: "/permission/update",
    },
    get: function (params) {
        return axios.get(permission.url.get, {
            params: params
        })
    },
    getPage: function (params) {
        return axios.get(permission.url.getPage, {
            params: params
        })
    },
    add: function (form) {
        return axios.post(permission.url.add, form)
    },
    update: function (form) {
        return axios.post(permission.url.update, form)
    },
}
export default permission